import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { cartState } from '../atoms/cartAtom';
import { motion, AnimatePresence } from 'framer-motion';
import { useBranding } from '../hooks/useBranding';

// color / hoverColor / hoverBackground let the navbar adapt the icon to its own background.
const CartIcon = ({ color = '#4b5563', hoverColor, hoverBackground = '#f3f4f6' }) => {
  const [cart, setCart] = useRecoilState(cartState);
  const [isHovered, setIsHovered] = useState(false);
  const { primaryColor } = useBranding();

  const colors = {
    primary: primaryColor || '#ff4d00'
  };

  const handleToggleCart = () => {
    setCart(prev => ({
      ...prev,
      isOpen: !prev.isOpen
    }));
  };

  return (
    <div className="relative">
      <button
        onClick={handleToggleCart}
        className="p-2 rounded-full focus:outline-none focus:ring-2 transition-all duration-300"
        style={{
          color: isHovered ? (hoverColor || colors.primary) : color,
          backgroundColor: isHovered ? hoverBackground : 'transparent',
          '--focus-ring-color': colors.primary + '50'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Panier"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
        
        <AnimatePresence>
          {cart.count > 0 && (
            <motion.div
              key="badge"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              className="absolute -top-1 -right-1 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
              style={{ backgroundColor: colors.primary }}
            >
              {cart.count}
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>
  );
};

export default CartIcon;